import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  aboutpage: any
  videoUrl:any
  userLoggedIn = false
  constructor(private service:AdminService, private sanitizer:DomSanitizer) { }

  ngOnInit(): void {
    this.service.getCinejoyAboutPage().subscribe(data=>{
      this.aboutpage = data.aboutPage;

      if(data.userId>0){
        this.userLoggedIn = true
      }
      else{
        this.userLoggedIn = false
      }
      
      var url = this.aboutpage.videoUrl;
      this.videoUrl= this.sanitizer.bypassSecurityTrustResourceUrl(url); 

    })
  }

}
